<template>
  <div class="control_bar top">
    <controller
      :dispItems="dispItems"
      :allItems="assigns"
      :router="router"
      @remove="remove"
    >
    </controller>
    <div class="false_modal_window" v-if="showFinishModal">
      <finishModalWindow :question="finishWord" @close="close">
      </finishModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
    <div class="import_modal_window" v-if="showImportModal">
      <importModalWindow @close="closeModal" @import="importFile">
      </importModalWindow>
    </div>
  </div>
</template>

<script>
import controller from '../controller.vue'
import finishModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import importModalWindow from '../modalWindow/importModalWindow.vue'

export default {
  props: ['dispItems'],
  data() {
    return {
      showFinishModal: false,
      finishWord: '',
      router: '/assigns/add',
      showloadingModal: false,
      showImportModal: false,
      records: [],
      csvData: []
    }
  },
  computed: {
    assigns() {
      return this.$store.state.assigns.assigns
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    selectedAssignList() {
      return this.$store.state.assigns.selectedAssignList
    }
  },
  components: {
    controller,
    finishModalWindow,
    loadingModalWindow,
    importModalWindow
  },
  methods: {
    close(e) {
      this.showFinishModal = false
    },
    closeModal(e) {
      this.showImportModal = false
      this.showFinishModal = false
    },
    async remove(e) {
      let selectedAssignIdList = this.selectedAssignList.map(
        assign => assign.id
      )
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'assigns/deleteAssigns',
          selectedAssignIdList
        )
        this.$store.dispatch('assigns/clearSelectedAssignList')
        this.finishWord = '対象の役割を削除しました。'
        this.showFinishModal = true
        // 削除ボタン押下時は詳細画面を初期化する
        if (location.pathname !== '/assigns') {
          this.$router.push('/assigns')
        }
        this.$emit('list-reload')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_660001
        let eventType = 3
        let reason = 'MSGCRC0225'
        if (error.response) {
          this.finishWord =
            this.errorMsg.MSGCRC0225.name +
            this.errorMsg.MSGCRC0225.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
.controller >>> .uploader,
.controller >>> .column_import,
.controller >>> .txt,
.controller >>> .column_import,
.controller >>> .column_export {
  color: #bbb;
  pointer-events: none;
}
.search {
  margin: auto 0;
  height: 55px;
}
</style>




// WEBPACK FOOTER //
// src/components/assigns/controlbar.vue